module.exports = __webpack_public_path__ + "static/media/bulb_4.af095477.png";